import { useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { LocalShipping, MoreHoriz, VpnKey } from '@mui/icons-material';
import {
  Alert,
  Box,
  FormControlLabel,
  Grid,
  Switch,
  Tab,
  Tabs,
} from '@mui/material';
import { IntegracaoContext } from 'contexts/IntegracaoContext';
import { DropsContext } from 'contexts/DropsContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import styles from './styles';

const IncubadoraE = ({ logo, loading, integracao }) => {
  const [tab, setTab] = useState(0);
  const access_data = integracao?.access_data;
  const defaultValues = {
    id: integracao?.id,
    //ACESSO
    nome_integracao: access_data?.nome_integracao || '',
    key: access_data?.key || '',
    //EXPEDICAO
    gerar_nf_retorno: access_data?.gerar_nf_retorno || null,
    //OUTROS
    users_id: access_data?.users_id || null,
    impressora_id: access_data?.impressora_id || null,
  };
  const { drops } = useContext(DropsContext);
  const { postIncubadoraR } = useContext(IntegracaoContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  const handleSave = (data) => {
    postIncubadoraR({ data });
  };

  return (
    <Container>
      <Header titulo="Configurações" />
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box sx={styles?.header}>
            <Box
              src={logo}
              component="img"
              sx={styles?.img}
              alt={integracao?.api}
            />
            <Tabs value={tab} onChange={(_, v) => setTab(v)}>
              <Tab
                value={0}
                icon={<VpnKey />}
                iconPosition="start"
                label="Acesso"
              />
              <Tab
                value={1}
                icon={<LocalShipping />}
                iconPosition="start"
                label="Expedição/Recebimento"
              />
              <Tab
                value={2}
                icon={<MoreHoriz />}
                iconPosition="start"
                label="Outros"
              />
            </Tabs>
          </Box>
        </Grid>
        <Grid item xs={12} display={tab === 0 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Input name="key" control={control} label="Chave da Integração" />
            </Grid>
            <Grid item xs={12}>
              <Input
                control={control}
                name="nome_integracao"
                label="Nome da Integração"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 1 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="gerar_nf_retorno"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Gerar NF de Remessa de Retorno Simbólico"
                    control={
                      <Switch
                        {...field}
                        checked={field?.value}
                        onChange={(e) => field?.onChange(e?.target?.checked)}
                      />
                    }
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} display={tab === 2 ? 'block' : 'none'}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Alert severity="warning">
                Atenção! É necessário criar um usuário ESPECÍFICO para a
                integração. Sugerimos criar um perfil usuário na entidade
                Emissora.
              </Alert>
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                name="users_id"
                control={control}
                options={drops?.Users}
                label="Usuário da Integração"
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                control={control}
                name="impressora_id"
                options={drops?.Impressoraweb}
                label="Impressora de Etiqueta de Expedição"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={styles?.bottom}>
        <Button
          color="primary"
          loading={loading}
          variant="contained"
          onClick={handleSubmit(handleSave)}
        >
          Salvar
        </Button>
      </Box>
    </Container>
  );
};

export default IncubadoraE;
